<template>
    <!-- 培训卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.name" @keyup.enter.native="getTrainingCard"    placeholder="班次名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getTrainingCard" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="addTraining">添加套餐项目</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="DataCompensationClicik">业务补偿</el-button>
				</el-form-item> -->
				
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="FrequencyCard" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="Id" width="0">
			</el-table-column> -->
			<el-table-column prop="Name" label="班次名称" width="200" sortable  >
			</el-table-column>
			<el-table-column prop="StartDate" label="开始日期" width="120" sortable :formatter="formatStartDate">
			</el-table-column>
			<el-table-column prop="EndDate" label="结束日期" width="120" sortable :formatter="formatEndDate">
			</el-table-column>
			<el-table-column prop="FinalTime" label="最终日期" width="120" sortable :formatter="formatFinalTime">
			</el-table-column>

			<el-table-column prop="Money" label="套餐金额" width="120" sortable>
			</el-table-column>
			<el-table-column prop="BeforTime" label="允许时差(分)" width="150" sortable>
			</el-table-column>
			<el-table-column prop="ClassHour" label="课时" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Remind" label="提醒课时" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="Count" label="人数" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Coach" label="教练" width="130" sortable>
			</el-table-column>           
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="State" label="套餐状态" width="120" sortable  fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">停用</el-tag>
                  <el-tag type="success" size="medium" v-else>启用</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column  label="变更状态" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="FrequencyCard[scope.$index].Id"   v-model="FrequencyCard[scope.$index].BoolState" active-color="#13ce66" inactive-color="#ff4949" @click.native.stop="SwitchChange(scope.row)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>	
			<el-table-column  label="上线开关" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="FrequencyCard[scope.$index].Id"   v-model="FrequencyCard[scope.$index].IsShow" active-color="#13ce66" inactive-color="#ff4949" @change="Change(scope.row.IsShow,FrequencyCard[scope.$index].Id)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>										
			<el-table-column label="操作" min-width="340" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="open(scope.row.Id)">延期</el-button>
					<el-button size="small" @click="handleEdit(scope.row)">编辑人数</el-button>
					<el-button size="small" @click="handleAdd(scope.row)">设置时间段</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">				
				<el-form-item label="套餐人数" prop="Count">
					<el-input v-model.number="editForm.Count" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增培训班" v-model="addTrainingVisible" :close-on-click-modal="false">
			<el-form :model="TrainingCardModel" label-width="130px" :rules="addTrainingFormRules" ref="addTrainingForm">
				<el-form-item label="班次名称" prop="Name">
					<el-input v-model="TrainingCardModel.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="开始时间" prop="StartDate">
					<el-date-picker v-model="TrainingCardModel.StartDate" type="date" placeholder="选择日期" > </el-date-picker>
				</el-form-item>
				
				<el-form-item label="结束时间" prop="EndDate">
					<el-date-picker v-model="TrainingCardModel.EndDate" type="date" placeholder="选择日期" > </el-date-picker>
				</el-form-item>
				<!-- <el-form-item label="结束时间" prop="EndDate">
					<el-date-picker v-model="TrainingCardModel.EndDate" type="date" placeholder="选择日期" > </el-date-picker>
				</el-form-item> -->
				<el-form-item label="最终时间" prop="FinalTime">
					<el-date-picker v-model="TrainingCardModel.FinalTime" type="date" placeholder="选择日期" > </el-date-picker>			
				</el-form-item>
				<el-form-item label="套餐金额" prop="Money">
					<el-input type="number" v-model.number="TrainingCardModel.Money" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="报名人数" prop="Count">
					<el-input type="number" v-model.number="TrainingCardModel.Count" auto-complete="off"></el-input>
				</el-form-item>				
				<el-form-item label="课时" prop="ClassHour">
					<el-input type="number"  v-model.number="TrainingCardModel.ClassHour" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="提醒课时" prop="Remind">
					<el-input type="number" v-model.number="TrainingCardModel.Remind" auto-complete="off"></el-input>
				</el-form-item>					
				<!-- <el-form-item label="周期(周)" prop="Cycle">
					<el-input v-model="TrainingCardModel.Cycle" auto-complete="off"></el-input>
				</el-form-item> -->
				
				<el-form-item label="允许时差(分)" prop="BeforTime">
					<el-input v-model.number="TrainingCardModel.BeforTime" auto-complete="off"></el-input>
				</el-form-item>
			   
				<!-- <el-form-item label="教练" prop="Coach">
					<el-input v-model="TrainingCardModel.Coach" auto-complete="off"></el-input>
				</el-form-item> -->
				<el-form-item label="备注">
					<el-input type="textarea" v-model="TrainingCardModel.Remark"></el-input>
				</el-form-item>							
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addTrainingVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmitTraining" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
 <el-dialog ref="shiftdialog" style="width:1500px; position:fixed; left:0.1%; margin-left:-125px; top:1%; margin-top:-69px; z-index:9999;"    :title='TrainingClassName' v-model="addFormVisible" :close-on-click-modal="false" >     
    <table id="Shift" style="border: 1px solid #ddd;    width: 100%; margin-bottom: 20px;   max-width: 100%;  background-color: transparent;" cellspacing="0" cellpadding="0">
           
            <tbody>
                <tr class="active">
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期一
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期二
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期三
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期四
                    </th>
                    <th style="text-align: center; width: 14%;background-color: #f5f5f5;">
                        星期五
                    </th>
                    <th style="text-align: center; width: 14%; color:#999;" >
                        星期六
                    </th>
                    <th style="text-align: center; width: 14%;color:#999;">
                        星期日
                    </th>
                </tr>
                <tr>
                        <td style="padding: 1px;border: 1px solid #ddd;"    >
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Monday" data-num="false" v-on:click="fun($event,'Monday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper"  v-for="arr in Monday" v-on:click.stop="selNum(arr,Monday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>

                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Tuesday" data-num="false"  v-on:click="fun($event,'Tuesday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <!-- <div slot="reference" class="name-wrapper" v-for="arr in td1" v-on:click.stop="selNum()">	 -->
                                <span slot="reference" class="name-wrapper" v-for="arr in Tuesday" v-on:click.stop="selNum(arr,Tuesday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>

                                </span>
								  <!-- </div> -->
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Wednesday" data-num="false"  v-on:click="fun($event,'Wednesday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								   <span slot="reference" class="name-wrapper" v-for="arr in Wednesday" v-on:click.stop="selNum(arr,Wednesday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Thursday" data-num="false"  v-on:click="fun($event,'Thursday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								   <span slot="reference" class="name-wrapper" v-for="arr in Thursday" v-on:click.stop="selNum(arr,Thursday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Friday" data-num="false"  v-on:click="fun($event,'Friday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								   <span slot="reference" class="name-wrapper" v-for="arr in Friday" v-on:click.stop="selNum(arr,Friday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Saturday" data-num="false"  v-on:click="fun($event,'Saturday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								   <span slot="reference" class="name-wrapper" v-for="arr in Saturday" v-on:click.stop="selNum(arr,Saturday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                        <td style="padding: 1px;border: 1px solid #ddd;">
                            <div class="_cell"  style="min-height: 350px; overflow: hidden;text-align: center;" ref="Sunday" data-num="false"  v-on:click="fun($event,'Sunday')" >
                                <ol style="list-style-type: none; margin-top: 25px">
                                </ol>
								  <span slot="reference" class="name-wrapper" v-for="arr in Sunday" v-on:click.stop="selNum(arr,Sunday)">
                               <el-tag size="medium">{{arr.StartTime}}-{{arr.EndTime}}</el-tag>
							   	 <br>
							   <br>
                                </span>
                            </div>
                        </td>
                </tr>
            </tbody>
        </table>

		<el-col :span="24" class="toolbar" style="padding-bottom: 10px;" >
			<el-form :inline="true" :model="filters" style="float: left;" ref="IntervalForm">
            <label >开始时间 <el-time-picker v-model="StartTime" :picker-options="{selectableRange: '01:00:00 - 23:59:00'}" placeholder="任意时间点" style="width:20%" :editable="false">
            </el-time-picker>
            </label>
             <label >结束时间 <el-time-picker v-model="EndTime" :picker-options="{selectableRange: '01:00:00 - 23:59:00'}" placeholder="任意时间点" style="width:20%" :editable="false">
            </el-time-picker>
            </label> 
			<!-- <label >提前时间 <el-input placeholder="请输入分钟数" v-model="BeforTime" clearable style="width:20%"> </el-input>
            </label> 			 -->
			<el-button type="success" @click.native="addTime" >添加时段</el-button>			
		    <el-button type="danger" @click.native="clear">清空</el-button>            
			</el-form>
		</el-col>
		<div slot="footer" class="dialog-footer">
				<el-button  @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
		</div>
     
	  </el-dialog>
	  				  <t-dialog :CardType="'4'" :msg="dialogValue" :show.sync="show"></t-dialog>		
	</section>
</template>
<script>
import util from '../../common/js/util'
	 import TDialog from './Zdialog';

import {addInterval,getIntervalList,getTrainingCardList,addTrainingCard,removeTrainingCard,editTrainingCard,DataCompensation,TrainingOnlineSet,LimitCount} from '../../api/api';
export default {
				components: {
            TDialog
        },
	data(){

		return {	
			dialogValue:'',
			show:false,
			// 操作时间段是的唯一id
			IntervalId:0,
			TrainingClassName:'',
			//培训卡项目新增模型
			TrainingCardModel:{
				Id:'',
				Name:'',
				StartDate:'',
				EndDate:'',
				FinalTime:'',
				ClassHour:0,
				Cycle:0,
				BeforTime:0,
				Coach:'',
				Money:0,
				Count:0,
				Remind:3
               
			},
           addTrainingVisible:false,


			addTrainingFormRules:{
               Name: [
						{ required: true, message: '请输入班次名称', trigger: 'blur' }
					],
			   ClassHour: [
						   {  required: true, message: '请输入课时总和', trigger: 'blur' },
						     { type: 'number', message: '必须为数字值'}
						// {  type:'number',  message: '请输入数字总和' ,trigger: 'change' }
					],
			   StartDate: [
                     { type: 'date', required: true, message: '请选择开始日期', trigger: 'change' }
					],	
			   EndDate: [
                    { type: 'date', required: true, message: '请选择结束日期', trigger: 'change' }
					],
			   FinalTime: [
                    { type: 'date', required: true, message: '请选择最终日期', trigger: 'change' }
					],
            //    Cycle: [
			// 		 { required: true, message: '请输入周期', trigger: 'blur' },
			// 		//  { min: 1, max: 2, message: '长度在2个字符', trigger: 'blur' },
			// 		//  { type: 'number', message: '周期必须为数字值'}
			// 		],
               BeforTime: [
					 { required: true, message: '请输入提前刷卡时间' },
					  { type: 'number', message: '必须为数字值'}
					//  {  type:'number', required: true, message: '提前刷卡时间必须为数字值', trigger: 'change' }
				    //  { type: 'number', message: '提前刷卡时间必须为数字值'}
					],	
				Count: [
						{ required: true, message: '请输入报名人数'},
                        { type: 'number', message: '必须为数字值'}
					],
							ClassHour: [
						{ required: true, message: '请输入课时'},
                        { type: 'number', message: '必须为数字值'}
					],
							Money: [
						{ required: true, message: '请输入金额'},
                        { type: 'number', message: '必须为数字值'}
					],	
									Remind: [
						{ required: true, message: '请输入提醒设置'},
                        { type: 'number', message: '必须为数字值'}
					],									
			},
			 //时间选择
			 StartTime:new Date(),
			 EndTime:new Date(),
			 BeforTime:0,
			Week:{
			   WeekName:'',
			   WeekList:[]
				},				
				//时间段结构体
				// Interval:[],
				handleState:'',//时段窗体的状态 是初始化
				OptionType:'',
				 TrainingComboId:'',
				  //操作结构体
				  strcut:[              
				  ],
				  SubmitStrcut:[],
				  strcuttitle:'',			  
			  //星期 模型
			  Monday:[],
			  Tuesday:[],
			  Wednesday:[],
			  Thursday:[],
			  Friday:[],
			  Saturday:[],
			  Sunday:[],
            td1backgroundColor:false,
			total:0,
			page:1,
			listLoading:false,
			filters:{
              name:''
			},
			sels: [],//列表选中列
            WeekSels:[],//选中的星期
			FrequencyCard:[],
			 editFormVisible:false,
			 editLoading:false,
			 editFormRules:{
				Count: [
						{ required: true, message: '请输入报名人数'},
                        { type: 'number', message: '必须为数字值'}
					],				 
			 },
			 editForm:{},			 
			addFormVisible:false,
			addLoading: false,
			// addFormRules:{},
			// //时段
			// addForm:{
			// 	Name:'',
			// 	StartDate:'',
			// 	EndDate:'',
			// 	FinalTime:'',
			// 	ClassHour:'',
			// 	BeforTime:'',
			// 	Cycle:'',
			// 	Coach:''
			// }
		}
	},
	methods:{
			open (value) {
			this.dialogValue=value;
                this.show = true;
            },	
			Change(State,index)
			{
				// row.IsShow=row.IsShow==false?true:false;		
				let para={
						Id:index,				
				}
              TrainingOnlineSet(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								    });
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},
		 SwitchChange(row){
						
			   row.State=row.BoolState==true?1:0;			 
				let para = {					
					Id:row.Id,
					Name:row.Name,
					StartDate:row.StartDate,
					EndDate:row.EndDate,
					FinalTime:row.FinalTime,
					ClassHour:row.ClassHour,
					cycle:row.cycle,
					BeforTime:row.BeforTime,
					Coach:row.Coach,
					State:row.State,
					Money:row.Money,
					Remark:row.Remark,
					BoolState:row.BoolState,
					TenancyId:row.TenancyId,
				}
		     	editTrainingCard(para).then((res)=>{				
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
	            });
	      	},				
		//第一次请求后台后，根据数据初始化选中列的结构体
		initStrcut(data,model){
			 this.strcut.forEach(item => {
				if(item.WeekName==data.WeekName)
				{
                  item.WeekList=model;
				}
		    	});
		},
		
		//第一次点击编辑时间段将数据添加入星期modou 并初始化 一选中的结构体 并且初始化样式
		addWeek(data){
              switch (data.WeekName) {
				  case 'Monday': 
				   {
					this.Monday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		              return  i.WeekName == 'Monday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Monday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Monday',
					    WeekList:this.Monday
						 }
				     this.strcut.push(this.Week);		 
				     }
                     
			            
					this.$refs['Monday'].style.backgroundColor = "#8391a5";
					this.$refs['Monday'].setAttribute('data-num','true');					
					break;
				   }
				   	case 'Tuesday': 
				   {
					this.Tuesday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		             return  i.WeekName == 'Tuesday'});
		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Tuesday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Tuesday',
					    WeekList:this.Tuesday
						 }
				     this.strcut.push(this.Week);		 
				     }
					this.$refs['Tuesday'].style.backgroundColor = "#8391a5";	
					this.$refs['Tuesday'].setAttribute('data-num','true');					
									
					break;
					}
				   	case 'Wednesday': 
				   {
					this.Wednesday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		              return  i.WeekName == 'Wednesday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Wednesday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Wednesday',
					    WeekList:this.Wednesday
						 }
				     this.strcut.push(this.Week);		 
				     }					
					this.$refs['Wednesday'].style.backgroundColor = "#8391a5";	
					this.$refs['Wednesday'].setAttribute('data-num','true');					
														
					break;
				   }
				   	case 'Thursday': 
				   {
					this.Thursday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		             return   i.WeekName == 'Thursday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Thursday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Thursday',
					    WeekList:this.Thursday
						 }
				     this.strcut.push(this.Week);		 
				     }

					this.$refs['Thursday'].style.backgroundColor = "#8391a5";
					this.$refs['Thursday'].setAttribute('data-num','true');					
																				
                     break;
				   }
				   	case 'Friday': 
				   {
					this.Friday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		             return   i.WeekName == 'Friday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Friday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Friday',
					    WeekList:this.Friday
						 }
				     this.strcut.push(this.Week);		 
				     }					
					this.$refs['Friday'].style.backgroundColor = "#8391a5";		
					this.$refs['Friday'].setAttribute('data-num','true');					
																							
					break;
				   }
				   case 'Saturday': 
				   {
					this.Saturday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		             return   i.WeekName == 'Saturday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Saturday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Saturday',
					    WeekList:this.Saturday
						 }
				     this.strcut.push(this.Week);		 
				     }					
					this.$refs['Saturday'].style.backgroundColor = "#8391a5";	
					this.$refs['Saturday'].setAttribute('data-num','true');					
																													
					break;
				   }
				   case 'Sunday': 
				   {
					this.Sunday.push(data);
					let selectStrcut=this.strcut.filter(i => {
		             return   i.WeekName == 'Sunday'});

		        	 if(selectStrcut.length>0)
		             {
                     this.initStrcut(data,this.Sunday);
		         	 }else
		         	 {
				    this.Week={
						WeekName:'Sunday',
					    WeekList:this.Sunday
						 }
				     this.strcut.push(this.Week);		 
				     }								
					this.$refs['Sunday'].style.backgroundColor = "#8391a5";	
					this.$refs['Sunday'].setAttribute('data-num','true');					
																																		
					break;
				   }				   				   
				   default:
				     break;
			  }
		},
		formatStartDate: function (row, column) {
				return util.formatDate.format(new Date(row.StartDate), 'yyyy-MM-dd');
			},
		formatEndDate: function (row, column) {
				return util.formatDate.format(new Date(row.EndDate), 'yyyy-MM-dd');
			},
		formatFinalTime: function (row, column) {
				return util.formatDate.format(new Date(row.FinalTime), 'yyyy-MM-dd');
			},
		//新增班次
		addSubmitTraining:function(){
				this.$refs.addTrainingForm.validate((valid) => {
					
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();							
							let para= Object.assign({}, this.TrainingCardModel);
							if(para.ClassHour<1)
							{
                                   this.$message({
									message: '课时设置请大于0',
									type: 'error'
									});		
									return;						
							}							
							para.StartDate = (!para.StartDate || para.StartDate == '') ? '' : util.formatDate.format(new Date(para.StartDate), 'yyyy-MM-dd');
							para.EndDate= (!para.EndDate || para.EndDate == '') ? '' : util.formatDate.format(new Date(para.EndDate), 'yyyy-MM-dd');
							para.FinalTime= (!para.FinalTime || para.FinalTime == '') ? '' : util.formatDate.format(new Date(para.FinalTime), 'yyyy-MM-dd');
							addTrainingCard(para).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['addTrainingForm'].resetFields();
								this.addTrainingVisible = false;
								this.getTrainingCard();
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
		},
		addTraining(){
		  this.addTrainingVisible=true;
		  this.TrainingCardModel={
				Id:'',
				Name:'',
				StartDate:'',
				EndDate:'',
				FinalTime:'',
				ClassHour:0,
				Cycle:0,
				BeforTime:15,
				Coach:'',	
				Count:0,
				Money:0,
				Remind:3			
			};
		},
		clear()
		{
			//清空数据 但是保持结构体 结构不变
			this.strcut.forEach(item=>{
			switch(item.WeekName)
				{
				   case 'Monday':
						  { this.Monday=[];  item.WeekList=[]; break; }
				   case 'Tuesday':	
						  { this.Tuesday=[]; item.WeekList=[]; break; }
				   case 'Wednesday':	
				      	  { this.Wednesday=[]; item.WeekList=[]; break; }	 
				   case 'Thursday':	
				      	  { this.Thursday=[]; item.WeekList=[]; break; }	 
				   case 'Friday':	
				      	  { this.Friday=[]; item.WeekList=[]; break; }	 
				   case 'Saturday':	
				      	  { this.Saturday=[]; item.WeekList=[]; break; }	 
				   case 'Sunday':	
				      	  { this.Sunday=[]; item.WeekList=[]; break; }	 								 
				   default:
				      break;
				}
			});


		},
		checkTime(WeekModel,Model)
		{
		   let FindModel=WeekModel.filter(i => {
			   util.formatDate.parse(new Date(row.FinalTime), 'yyyy-MM-dd');
			if(i.StartTime<=Model.StartTime&&i.EndTime>=Model.EndTime)
			{
				return ;
			}
			if(i.StartTime<=Model.EndTime&&i.EndTime>=Model.EndTime)
			{
				return ;
			}
		   });
		   if(FindModel.length>0)
		   {//如果时间段有找到
			  return true;
		   }
		   else
		   {
			  return  false;
		   }
		},
		addTime(){

			let Stime=util.formatDate.format(new Date(this.StartTime), 'hh:mm');
			let Etime=util.formatDate.format(new Date(this.EndTime), 'hh:mm');
   
			this.strcut.forEach(item=>{
		     	 let addModel={
					Id:String(++this.IntervalId),
					StartTime:Stime,
					EndTime:Etime,
					WeekName:item.WeekName
					   }
				switch(item.WeekName)
					{
 				   case 'Monday':
						  { 
							//    let Result=this.checkTime(this.Monday,addModel); console.log(Result);
							   this.Monday.push(addModel); item.WeekList=this.Monday;  break; }
				   case 'Tuesday':	
						  { this.Tuesday.push(addModel);item.WeekList=this.Tuesday;  break; }
				   case 'Wednesday':	
				      	  { this.Wednesday.push(addModel);item.WeekList=this.Wednesday;  break; }	 
				   case 'Thursday':	
				      	  { this.Thursday.push(addModel);item.WeekList=this.Thursday;  break; }	 	 
				   case 'Friday':	
				      	  { this.Friday.push(addModel); item.WeekList=this.Friday; break; }	  
				   case 'Saturday':	
				      	  { this.Saturday.push(addModel);  item.WeekList=this.Saturday; break; }	 
				   case 'Sunday':	
				      	  { this.Sunday.push(addModel); item.WeekList=this.Sunday; break; }	 								 
				   default:
				      break;                      
					}
				   
			   })
  
		},
		delete(value){
            this.strcut = this.strcut.filter(i => {
		    return i.WeekName != value});
		},
		//业务补偿
		DataCompensationClicik()
		{
			let para={}
            DataCompensation(para).then((res)=>{})
		},
	    delWeekInterval(){
          
		  },
		selNum(Row,Model){
		
	        Model=Model.filter(i=>{
			return i.Id!=Row.Id
			})
			switch(Row.WeekName)
			{
				case 'Monday':
				{this.Monday=Model;
				break }
				case 'Tuesday':
				{this.Tuesday=Model;break }
				case 'Wednesday':
				{this.Wednesday=Model;break }
				case 'Thursday':
				{this.Thursday=Model;break }
				case 'Friday':
				{this.Friday=Model ;break}
				case 'Saturday':
				{this.Saturday=Model;break }
				case 'Sunday':
				{this.Sunday=Model ;break}

				default :
				 break
			}
			// Model.items.$remove(row);
			
			//此方法什么都不做 仅用于 中断系统的冒泡事件 防止外层div事件 附加到内层 元素上
			// 2018-9-5 客户看完后 此处不在中断系统冒泡 改为 点击修改  单个修改时间段
		},
		fun(e,value){
			  if(e.target.getAttribute('data-num')=='false')
			  {
				 e.target.style.backgroundColor ="#8391a5";
				 e.target.setAttribute('data-num','true');
				//新增时间段
			    switch(value)
				   {
					//在结构体中新增 项目
				   case 'Monday': 
				   {
					this.Week={
						WeekName:'Monday',
					    WeekList:this.Monday
					};					
					this.strcut.push(this.Week);
					break;
				   }
				   	case 'Tuesday': 
				   {
					this.Week={
						WeekName:'Tuesday',
					    WeekList:this.Tuesday
					};
					this.strcut.push(this.Week);
					break;
					}
				   	case 'Wednesday': 
				   {
                     this.Week={
						WeekName:'Wednesday',
					    WeekList:this.Wednesday
					};
					this.strcut.push(this.Week);
					break;
				   }
				   	case 'Thursday': 
				   {
                    this.Week={
						WeekName:'Thursday',
					    WeekList:this.Thursday
					};
					this.strcut.push(this.Week);

                     break;
				   }
				   	case 'Friday': 
				   {
                    this.Week={
						WeekName:'Friday',
					    WeekList:this.Friday
					};
					this.strcut.push(this.Week);
					break;
				   }
				   case 'Saturday': 
				   {
                   this.Week={
						WeekName:'Saturday',
					    WeekList:this.Saturday
					};
					this.strcut.push(this.Week);
					break;
				   }
				   case 'Sunday': 
				   {
                    this.Week={
						WeekName:'Sunday',
					    WeekList:this.Sunday
					};
					this.strcut.push(this.Week);
					break;
				   }				   				   
				   default:
				     break;
				}
				//灰 #8391a5 白#FFFFFF
			  }
			  else
			  {
				  //取消选中 同时从结构体中删除 结构项
			   e.target.style.backgroundColor = "#FFFFFF";
			    e.target.setAttribute('data-num','false');
              switch(value)
				{
				   case 'Monday': 
				   {
                    this.delete(value);
					break;
				   }
				   	case 'Tuesday': 
				   {
                    this.delete(value);
					break;
					}
				   	case 'Wednesday': 
				   {
                    this.delete(value);
					break;
				   }
				   	case 'Thursday': 
				   {
                    this.delete(value);
                     break;
				   }
				   	case 'Friday': 
				   {
                    this.delete(value);
					break;
				   }
				   case 'Saturday': 
				   {
                    this.delete(value);
					break;
				   }
				   case 'Sunday': 
				   {
                    this.delete(value);
					break;
				   }				   				   
				   default:
				     break;
				}
			  }
				 
			},

			handleEdit: function ( row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			editSubmit(){
				this.$confirm('确认编辑该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					// this.listLoading = true;
					//NProgress.start();
					let para = Object.assign({}, this.editForm);
					LimitCount(para).then((res) => {
						// this.listLoading = false;
						//NProgress.done();
						
						 if(res.data.Success==true)
						 {
						// row.Count=this.editForm.Count;
						this.editFormVisible=false;							 
						this.$message({
							message: '编辑成功',
							type: 'success'
						});

						this.getTrainingCard();
						 }else
						 {
							this.$message({
							message: res.data.Msg,
							type: 'error'
						}); 
						 }
					});
				}).catch(() => {
				});
			},
		//删除
		handleDel(row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { Id:row.Id};
					removeTrainingCard(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						 if(res.data.Success==true)
						 {
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getTrainingCard();

						 }else
						 {
							this.$message({
							message: res.data.Msg,
							type: 'error'
						}); 
						 }


					});
				}).catch(() => {

				});
			},
		handleCurrentChange(val) {
				this.page = val;
				this.getTrainingCard();
			},
		selsChange: function (sels) {
				this.sels = sels;
			},
		//显示新增或编辑时段界面
		handleAdd: function (row) {
			      this.TrainingClassName='时间段设定('+row.Name+')';
				  this.TrainingComboId=row.Id;
				  let para={
                     TrainingComboId:row.Id
				  };
				  	    this.Monday=[];
			            this.Tuesday=[];
		               	this.Wednesday=[];
			            this.Thursday=[];
			            this.Friday=[];
			            this.Saturday=[];
						this.Sunday=[];
						this.strcut=[];

				  this.addFormVisible = true;						
				getIntervalList(para).then((res)=>{
					
					let	{status,data}=res;
					
					if(status==200)
					{
						if(data.length>0)
						{
							this.OptionType='Edit';
							// this.Interval=data;
						  this.$refs['Monday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Monday'].setAttribute('data-num','false');					
						  this.$refs['Tuesday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Tuesday'].setAttribute('data-num','false');					

						  this.$refs['Wednesday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Wednesday'].setAttribute('data-num','false');					

						  this.$refs['Thursday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Thursday'].setAttribute('data-num','false');					

						  this.$refs['Friday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Friday'].setAttribute('data-num','false');					

						  this.$refs['Saturday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Saturday'].setAttribute('data-num','false');					

						  this.$refs['Sunday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Sunday'].setAttribute('data-num','false');	
						  //如果时间段存在 改变样式且 对数据进行赋值
						  data.forEach(item => {
							 this.addWeek(item); 
						  });
						}
						else
						{
						  this.OptionType='Create';
						  this.$refs['Monday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Monday'].setAttribute('data-num','false');					
						  this.$refs['Tuesday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Tuesday'].setAttribute('data-num','false');					

						  this.$refs['Wednesday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Wednesday'].setAttribute('data-num','false');					

						  this.$refs['Thursday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Thursday'].setAttribute('data-num','false');					

						  this.$refs['Friday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Friday'].setAttribute('data-num','false');					

						  this.$refs['Saturday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Saturday'].setAttribute('data-num','false');					

						  this.$refs['Sunday'].style.backgroundColor = "#FFFFFF";
						  this.$refs['Sunday'].setAttribute('data-num','false');					


						}
                       
					}
				})
				.catch(error=>{
                 alert('网络错误');
                });
				// this.addForm = {										
				// };
				},
		getTrainingCard(){
		let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.name
				};
				this.listLoading = true;
				console.log(para);
				getTrainingCardList(para).then((res)=>{
					this.total = res.data.TotleCount;
					this.FrequencyCard =res.data.Data;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
		},
		SubmitStrcutInit(){
		   if(this.Monday.length>0)
		   {
		     this.Week={
				WeekName:'Monday',
				WeekList:this.Monday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		  if(this.Tuesday.length>0)
		   {

		     this.Week={
				WeekName:'Tuesday',
				WeekList:this.Tuesday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.Wednesday.length>0)
		   {

		     this.Week={
				WeekName:'Wednesday',
				WeekList:this.Wednesday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.Thursday.length>0)
		   {
		     this.Week={
				WeekName:'Thursday',
				WeekList:this.Thursday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.Friday.length>0)
		   {
		    this.Week={
				WeekName:'Friday',
				WeekList:this.Friday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.Saturday.length>0)
		   {
		     this.Week={
				WeekName:'Saturday',
				WeekList:this.Saturday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }
		   if(this.Sunday.length>0)
		   {

		    this.Week={
				WeekName:'Sunday',
				WeekList:this.Sunday
			 }
			 this.SubmitStrcut.push(this.Week);
		   }

		},
		//新增
		addSubmit: function () {
				this.$refs.IntervalForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							// let para= Object.assign({}, this.addForm);	
							this.SubmitStrcut=[];
							this.SubmitStrcutInit();
							let para={
								OptionType:this.OptionType,
								TrainingComboId:this.TrainingComboId,
                                strcut:JSON.stringify(this.SubmitStrcut)
							}		
							addInterval(para).then((res) => {	
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                this.$message({
									message: Msg,
									type: 'success'
								});
								this.$refs['IntervalForm'].resetFields();
								this.addFormVisible = false;
								this.getTrainingCard();

								}else
								{
                                this.$message({
									message: Msg,
									type: 'error'
								});
								}
							}) .catch(error=>{
							this.addLoading = false;

                            alert('系统错误');
                            });														
						});
					}
				});
			},		
	}

	,
		mounted() {
			this.getTrainingCard();
		}
}
</script>
<style scoped >
/* .el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
} */
/* .el-dialog--small {
    width: 80%
} */

</style>



// WEBPACK FOOTER //
// TrainingCard.vue?fb6e1a48